import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { updateTVProductMappings } from '../../SetupActions';

class UnifyMappingTableProductRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.submitting) {
      const { program, product } = this.props;

      this.setState({ submitting: true }, () => {
        const params = {
          client_id: program.client_id,
          program_id: program.program_id,
          use_product_mappings: false,
          mappings: [
            {
              ts_product_id: product.id, // yes, use tv product id for this.
              tv_product_id: product.selected ? null : product.id,
            }
          ],
        };
        this.props.dispatch(updateTVProductMappings(params))
          .then(
            () => {
              this.setState({ submitting: false });
            },
            (er) => {
              this.setState({ submitting: false });
              console.log(er);
            },
          );
      });
    }
  }

  render() {
    const { product } = this.props;
    const { submitting } = this.state;
    const sty = submitting ? { cursor: 'not-allowed' } : { cursor: 'pointer' };
    let iconName = product.selected ? 'check-square-o' : 'square-o';
    let cls = product.selected ? 'text-success' : '';
    if (submitting) {
      iconName = 'spinner';
      cls = 'text-muted';
    }

    return (
      <tr style={sty} key={product.id} onClick={this.handleToggle}>
        <td width="35" className="text-center">
          <Fa className={cls} name={iconName} spin={submitting} />
        </td>
        <td>
          {product.name}
        </td>
      </tr>
    );
  }
}

UnifyMappingTableProductRow.propTypes = {
  dispatch: PropTypes.func.isRequired,
  program: PropTypes.shape({
    client_id: PropTypes.string,
    program_id: PropTypes.string,
  }).isRequired,
  product: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool,
  }).isRequired,
};
UnifyMappingTableProductRow.defaultProps = {
  onSubmitting: () => {},
  onDone: () => {},
};

function mapStateToProps() {
  return {};
}


export default connect(mapStateToProps)(UnifyMappingTableProductRow);
